<template>
  <el-form ref="judgmentForm" :inline="false" :model="vicePresidentAJudgment" label-width="150px">
    <!-- if not a reappraisal app -->
    <div v-if="!isReappraisal">
      <el-card>
      <el-form-item label="Εισήγηση Ειδ. Εισηγητή:" size="small">
        <span v-html="specialProponentProposal"></span>
      </el-form-item>
      <el-form-item label="Ημ/νια εισήγησης:" size="small">
        {{reviewProposalDate}}
       </el-form-item>
      <el-form-item label="Σχόλιο Προέδρου:" size="small">
        {{presidentComment}}
      </el-form-item>
      </el-card>
    </div>
    <!-- if reappraisal app from prechecker -->
    <div v-if="isReappraisal && (fromPrechecker || fromPresident)">
      <el-form-item label="Αρμόδιος Εισηγητής:" size="small">
        <span>{{ proponentInCharge }}</span>
      </el-form-item>
    </div>
    <!-- common items for all -->
    <el-form-item label="Εσωτερικό Σχόλιο:">
      <el-input type="textarea" class="commentText" placeholder="Εισάγετε εσωτερικό σχόλιο"
        v-model="vicePresidentAJudgment.internalComment"
        :autosize="{ minRows: 4, maxRows: 10 }" @change="modifyInternalComment">
      </el-input>
    </el-form-item>
    <proposals></proposals>
    <internalComments></internalComments>
        <!-- show decision board -->
    <div v-if="showDSDecisionText">
      <el-form-item label="Απόφαση Δ.Σ.:" size="small">
        <el-input @change="modifyViceComment"
          type="textarea" class="commentText"
          :autosize="{ minRows: 4, maxRows: 10}" size="100"
          placeholder="Εισάγετε το αποτέλεσμα της ψηφοφορίας του Δ.Σ."
          v-model="vicePresidentAJudgment.comment">
        </el-input>
      </el-form-item>
      <el-form-item v-if="isReappraisal && (!praktikoDSFound || viceUploaded || this.workingApplication.attachedDocuments.slice(-1)[0].uploadedBy === this.currentUser.id)" label="Πρακτικό Δ.Σ.">
        <el-upload
          class="upload-demo"
          ref="upload"
          accept=".pdf"
          action=""
          :file-list="this.viceAttachments.filter(doc => doc.type === calcFileType)"
          :http-request="addAttachment"
          :on-remove="handleRemove"
          :before-remove="handleBeforeRemove"
          :on-preview="viewPdf"
          v-loading="this.uploading"
          :auto-upload="true"
          :show-file-list="true"
          :limit="1">
          <el-button v-if="attachments.length===0"
            slot="trigger"
            type="primary" size="small">Επιλογή Αρχείου
          </el-button>
          <div slot="tip" class="el-upload__tip">** Ανεβάστε το πρακτικό του Δ.Σ. (προαιρετικά)</div>
        </el-upload>
      </el-form-item>
      <el-form-item v-if="praktikoDSFound">
        <el-alert type="info" title="Yπάρχει ανεβασμένο το πρακτικό ΔΣ (στην καρτέλα Επισυναπτόμενα)" show-icon></el-alert>
      </el-form-item>
    </div>
    <!-- if reappraisal app from board -->
    <div v-if="isReappraisal && fromBoard">
      <el-card hit shadow class="box-card">
      <div slot="header" class="clearfix" v-if="boardJudgement">Αποφάσεις Μελών Εκτελεστικής Επιτροπής
        <el-table :data="boardJudgement.judgment" style="width: 100%">
          <el-table-column label="Όνομα"  width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.firstname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Επώνυμο"  width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.surname }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="!isReappraisal" label="Αποδοχή πρότασης" align="center">
            <el-table-column label="Εισηγητή"  width="90" align="center">
              <template slot-scope="scope">
                <span class="agree-btn" v-if="scope.row.agreeWithProponent === true"> <i class="el-icon-check"></i></span>
                <span class="disagree-btn" v-if="scope.row.agreeWithProponent === false"> <i class="el-icon-close"></i></span>
              </template>
            </el-table-column>
            <el-table-column label="Ακαδημαικού Συμβούλου"  width="110" v-if='fromConsultant' align="center">
              <template slot-scope="scope">
                <span class="agree-btn" v-if="scope.row.agreeWithAC === true"> <i class="el-icon-check"></i></span>
                <span class="disagree-btn" v-if="scope.row.agreeWithAC === false"> <i class="el-icon-close"></i></span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column v-if="isReappraisal" label="Πλήρης αποδοχή" align="center" width="150">
            <template slot-scope="scope">
              <span class="agree-btn" v-if="scope.row.fullyAgreeWithReappraisal === true"> <i class="el-icon-check"></i></span>
              <span class="disagree-btn" v-if="scope.row.fullyAgreeWithReappraisal === false"> <i class="el-icon-close"></i></span>
            </template>
          </el-table-column>
          <el-table-column label="Εισήγηση">
            <template slot-scope="scope">
              <el-popover trigger="click" placement="top-start"
                title= "Εισήγηση: ">
                <span slot="reference" style="color: blue">Πατήστε για άνοιγμα</span>
                <span v-html="scope.row.proposal"></span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="Υποβολή"  width="85" align="center">
            <template slot-scope="scope">
              <span class="done-btn" v-if="scope.row.finalize === true"> <i class="el-icon-check"></i></span>
              <span class="pending-btn" v-if="scope.row.finalize === false"> <i class="el-icon-edit"></i></span>
              <!-- <el-button type="success" icon="el-icon-check" size="mini" round v-if="scope.row.finalize">Οριστική</el-button>
              <el-button type="warning" icon="el-icon-edit" size="mini" round v-if="!scope.row.finalize">Προσωρινή</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      </el-card>
      <el-form-item label="Ανάθεση " v-if="!this.reappraisalBoardExists">
        <el-select v-model="vicePresidentAJudgment.assignedTo.role" placeholder="Παρακαλώ Επιλέξτε" @change="toggleAssignTo">
          <el-option label="σε Ειδ. Επιτρ. Επανεξέτασης" value="SpecialReappraisalBoardMember"></el-option>
          <el-option v-if="!this.vicePresidentAJudgment.boardUnanimous" label="σε Πρόεδρο" value="President"></el-option>
        </el-select>
      </el-form-item>
      <!-- if reapraisal board does not already exist but app is assigned to reappraisal board member -->
      <div v-if="!reappraisalBoardExists && vicePresidentAJudgment.assignedTo.role === 'SpecialReappraisalBoardMember'">
        <el-form-item size="small">Ορισμός Ειδικής Επιτροπής Επανεξέτασης
        </el-form-item>
        <el-form-item label="Πρακτικό ορισμού" size="small">
          <el-input type="text"
            v-model="reappraisalBoardRec">
          </el-input>
          <el-button size="mini" type="primary" @click="newReappraisalBoard">Νέα Επιτροπή</el-button>
        </el-form-item>
        <el-form-item>
        </el-form-item>
      </div>
      <div v-if="reappraisalBoardExists && vicePresidentAJudgment.assignedTo.role">
        <el-card hit shadow class="box-card">
        <div slot="header" style="margin-top:5px; margin-bottom: 5px">Μέλη Ειδικής Επιτροπής Επανεξέτασης
        <!-- <el-form-item> -->
          <el-alert
            type="info"
            :title="'Βρέθηκε η υπ.αριθμ. ' + this.reappraisalBoard.name + ' ειδική επιτροπή'"
            show-icon>
          </el-alert>
        <!-- </el-form-item> -->
        <el-transfer
          v-loading="loadingInternalUsers"
          style="margin-top: 20px; text-align: left; display: inline-block"
          v-model="reappraisalBoard.members"
          filterable
          :titles="['Διαθέσιμοι Χρήστες', 'Μέλη επιτροπής']"
          :button-texts="['Αφαίρεση', 'Προσθήκη']"
          :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }"
          :data="users"
          @change="addUserToReappBoard"
          @left-check-change="usersToAssignChanged"
          @right-check-change="usersToReleaseChanged">
        </el-transfer>
        <!-- </el-form-item> -->
        </div>
      </el-card>
      </div>
    </div>
    <!-- if reappraisal app from reappraisal board -->
    <div v-if="isReappraisal && fromReappraisalBoard">
      <el-card>Απόφαση Επιτροπής Επανεξέτασης
        <el-table :data="reappraisalBoardJudgment" style="width: 100%">
          <el-table-column label="Όνομα">
            <template slot-scope="scope">
              <span>{{ scope.row.firstname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Επώνυμο">
            <template slot-scope="scope">
              <span>{{ scope.row.surname }}</span>
            </template>
          </el-table-column>
           <el-table-column label="Ημ/νία">
            <template slot-scope="scope">
              <span>{{ scope.row.date.substring(0,10) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="isReappraisal" label="Πλήρης αποδοχή" align="center">
            <template slot-scope="scope">
              <span class="agree-btn" v-if="scope.row.fullyAgreeWithReappraisal === true"> <i class="el-icon-check"></i></span>
              <span class="disagree-btn" v-if="scope.row.fullyAgreeWithReappraisal === false"> <i class="el-icon-close"></i></span>
              <span class="pending-btn" v-if="scope.row.fullyAgreeWithReappraisal === null"> <i class="el-icon-minus"></i></span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <div style="text-align: center">
      <el-button size="mini" type="primary" round="" @click="tempSave()">Αποθήκευση</el-button>
      <el-button size="mini" type="danger" round="" :disabled="cannotSave" @click="finalSave()">Ολοκλήρωση</el-button>
    </div>
  </el-form>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
import internalComments from '../common/internalComments'
import Proposals from '../common/Proposals'
import sharedMethods from '../common/sharedMethods.js'
import dictionary from '../../store/dictionary'
import shortDictionary from '../../store/shortDictionary'

export default {
  components: {
    internalComments,
    Proposals,
    dictionary,
    shortDictionary
  },
  mixins: [sharedMethods],
  props: ['application', 'isReappraisal'],
  mounted: function () {
    if (this.fromBoard) {
      axios.get(`${this.BASE_URL}/reappraisal_boards?application_id=` + this.workingApplication.id
      ).then((response) => {
        // response.data.data.length !== 0 ? this.reappraisalBoard = response.data.data[0].id : this.reappraisalBoard = null
        if (response.data.data.length !== 0) {
          this.reappraisalBoardExists = true
          this.reappraisalBoard = response.data.data[0]
          this.reappraisalBoard.members = this.reappraisalBoard.members.map(member => member.memberId)
          this.vicePresidentAJudgment.assignedTo.role = 'SpecialReappraisalBoardMember'
        } else {
          this.reappraisalBoardExists = false
          this.$notify.warning({
            title: 'Ειδοποίηση',
            message: 'Δεν έχει οριστεί Ειδική Επιτροπή Επανεξέτασης',
            offset: 100
          })
        }
      }, (err) => {
        // this.backendError(err)
        console.log(err.response.data)
      })
    }
  },
  data () {
    return {
      modified: false,
      vicePresidentCall: '',
      selectedUsers: [],
      dialogView: false,
      reappraisalBoard: {
        id: null,
        name: null,
        members: []
      },
      reappraisalBoardExists: null,
      uploading: false,
      attachments: [],
      reappraisalBoardRec: ''
    }
  },
  methods: {
    translate (term) {
      return shortDictionary[term]
    },
    addAttachment (file, fileList) {
      this.attachments.push(file.file)
      let self = this
      return this.getData(file.file).then(data => {
        self.fileData = data
        self.fileName = file.file.name
        self.newAttachment()
      })
    },
    getData (file) {
      return new Promise((resolve, reject) => {
        const fReader = new FileReader()
        let base64Pdf
        fReader.onload = (fileLoadedEvent) => {
          base64Pdf = fileLoadedEvent.target.result
          resolve(base64Pdf.split(',')[1])
        }
        fReader.readAsDataURL(file)
      })
    },
    newAttachment () {
      let filetype
      if (this.fromReappraisalBoard) {
        filetype = 26
      } else filetype = 24
      let payload = {
        file: this.fileData,
        name: this.fileName,
        type: filetype,
        uuid: this.currentUser.id
      }
      this.uploading = true
      axios.post(
        `${this.BASE_URL}/users/uid/applications/${this.workingApplication.id}/attachments`, payload
      ).then((response) => {
        let id = response.data.data.id
        this.uploading = false
        this.frontEndSuccessMsg('Το αρχείο επισυνάφθηκε με επιτυχία')
        let viceAttached = this.viceAttachments.slice(0)
        viceAttached[viceAttached.length] = {type: payload.type, name: payload.name, uid: payload.uuid, id: id}
        this.$store.dispatch('SET_VICE_ATTACHMENTS', viceAttached)
      }).catch(err => {
        this.frontEndError('Σφάλμα κατά την επισύναψη του αρχείου')
        this.catchError(err)
      })
    },
    handleRemove (file, fileList) {
      this.attachments = []
      this.fileData = ''
      this.fileName = ''
      this.deleteAttachment(file)
    },
    handleBeforeRemove (file, fileList) {
      return this.$confirm(`Να αφαιρεθεί το ${file.name}？`)
    },
    deleteAttachment (file) {
      this.uploading = true
      axios.delete(
        `${this.BASE_URL}/users/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments/${file.id}`
      ).then((response) => {
        this.uploading = false
        this.$store.dispatch('SET_VICE_ATTACHMENTS', this.viceAttachments.filter(attachment => attachment.id !== file.id))
        this.frontEndSuccessMsg('Διαγραφή αρχείου επιτυχής')
      }).catch(err => {
        this.saving = false
        this.frontEndError('Διαγραφή αρχείου μη επιτυχής')
        this.catchError(err)
      })
    },
    viewPdf (file) {
      const base64Data = encodeURI(this.fileData)
      this.openPdfWindow(file.name, base64Data)
    },
    toggleAssignTo (val) {
      if (this.vicePresidentAJudgment.assignedTo.role === 'SpecialReappraisalBoardMember') {
        this.showReappraisalBoardTool = true
      } else this.showReappraisalBoardTool = false
    },
    addUserToReappBoard (rightListItems, dir, movedItems) {
      if (rightListItems.length === 3 || rightListItems.length === 0) {
        axios.put(`${this.BASE_URL}/reappraisal_boards/${this.reappraisalBoard.id}`,
          {
            membersId: rightListItems
          }
        ).then((response) => {
          this.$notify.success({
            title: 'Ειδοποίηση',
            message: `Επιτυχής ορισμός μελών ειδικής επιτροπής`,
            offset: 100
          })
        }).catch(err => {
          this.submitingAuditList = false
          this.frontEndError('Σφάλμα κατά τον ορισμό μελών ειδικής επιτροπής επανεξέτασης')
          this.backendError(err)
        })
      } else {
        this.$message({
          type: 'warning',
          message: 'Μια επιτροπή πρέπει να έχει ακριβώς τρία μέλη'
        })
        // rightListItems = rightListItems.concat(movedItems)
      }
    },
    usersToAssignChanged (users) {
      // console.log(this.reappraisalBoardMembers.concat(users).length)
      // if (this.reappraisalBoardMembers.concat(users).length > 3) {
      //   this.$message({
      //     type: 'info',
      //     message: 'Δεν επιτρέπεται ορισμός επιτροπής με περισσότερα από τρία μέλη'
      //   })
      // }
    },
    usersToReleaseChanged () {
    },
    newReappraisalBoard () {
      axios.post(`${this.BASE_URL}/reappraisal_boards`,
        {
          name: this.workingApplication.protocol,
          application_id: this.workingApplication.id,
          comment: this.reappraisalBoardRec
        }
      ).then((response) => {
        this.frontEndSuccessMsg('Η επιτροπή δημιουργήθηκε!')
        this.reappraisalBoardExists = true
        this.reappraisalBoard = response.data.data
      }).catch(err => {
        this.frontEndError('Παρουσιάστηκε σφάλμα κατά τη δημιουργία της επιτροπής!')
        this.catchError(err)
      })
    },
    finalSave () {
      let msg
      if (this.isReappraisal) {
        if (this.fromPrechecker || (this.workingApplication.overdue && this.fromPresident)) {
          this.vicePresidentAJudgment.assignedTo = {
            uid: null,
            role: 'ExecutiveBoardMember'
          }
          msg = 'Η αίτηση δρομολογείται προς την Εκτελεστική Επιτροπή. Μετά το πέρας της διαδικασίας δεν θα μπορείτε να προβείτε σε αλλαγές. Ειστε σίγουροι ότι θέλετε να συνεχίσετε;'
        } else if (this.fromBoard) {
          if (this.vicePresidentAJudgment.boardUnanimous) {
            this.vicePresidentAJudgment.assignedTo.role = 'SpecialReappraisalBoardMember'
            msg = 'Η αίτηση δρομολογείται προς Ειδική Επιτροπή Επανεξέτασης. Μετά το πέρας της διαδικασίας δεν θα μπορείτε να προβείτε σε αλλαγές. Ειστε σίγουροι ότι θέλετε να συνεχίσετε;'
          }
          if (this.vicePresidentAJudgment.assignedTo.role === 'President') {
            msg = 'Η αίτηση δρομολογείται προς τον Πρόεδρο. Μετά το πέρας της διαδικασίας δεν θα μπορείτε να προβείτε σε αλλαγές. Ειστε σίγουροι ότι θέλετε να συνεχίσετε;'
          } else if (this.vicePresidentAJudgment.assignedTo.role === 'SpecialReappraisalBoardMember') {
            msg = 'Η αίτηση δρομολογείται προς Ειδική Επιτροπή Επανεξέτασης. Μετά το πέρας της διαδικασίας δεν θα μπορείτε να προβείτε σε αλλαγές. Ειστε σίγουροι ότι θέλετε να συνεχίσετε;'
          }
        } else if (this.fromReappraisalBoard) {
          this.vicePresidentAJudgment.assignedTo = {
            uid: null,
            role: 'President'
          }
          msg = 'Η αίτηση δρομολογείται προς τον Πρόεδρο. Μετά το πέρας της διαδικασίας δεν θα μπορείτε να προβείτε σε αλλαγές. Ειστε σίγουροι ότι θέλετε να συνεχίσετε;'
        }
      } else if (!this.isReappraisal) {
        msg = 'Η αίτηση δρομολογείται προς τον Πρόεδρο. Μετά το πέρας της διαδικασίας δεν θα μπορείτε να προβείτε σε αλλαγές. Ειστε σίγουροι ότι θέλετε να συνεχίσετε;'
      }
      this.$confirm(msg,
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        // only for testing
        axios.put(
          `${this.BASE_URL}/${this.activeRole.toLowerCase()}s/uid/applications/${this.workingApplication.id}/final`,
          {
            judgment: {
              internalComment: this.vicePresidentAJudgment.internalComment,
              comment: this.vicePresidentAJudgment.comment,
              assignedTo: this.vicePresidentAJudgment.assignedTo
            }
          }
        ).then((response) => {
          this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
          this.frontEndSuccessMsg('Η αίτηση προωθήθηκε με επιτυχία')
        }).catch(err => {
          this.frontEndError('Σφάλμα κατά την οριστική αποθήκευση')
          this.catchError(err)
        })
      })
    },
    tempSave () {
      let payload
      if (this.isReappraisal && this.fromBoard) {
        payload = {
          internalComment: this.vicePresidentAJudgment.internalComment,
          comment: this.vicePresidentAJudgment.comment,
          assignedTo: this.vicePresidentAJudgment.assignedTo ? this.vicePresidentAJudgment.assignedTo : {role: null, uid: null},
          boardUnanimous: this.vicePresidentAJudgment.boardUnanimous
        }
      } else {
        payload = {
          internalComment: this.vicePresidentAJudgment.internalComment,
          comment: this.vicePresidentAJudgment.comment
          // assignedTo: this.vicePresidentAJudgment.assignedTo ? this.vicePresidentAJudgment.assignedTo : {role: null, uid: null}
        }
      }
      axios.put(
        `${this.BASE_URL}/${this.activeRole.toLowerCase()}s/uid/applications/${this.workingApplication.id}/temp`, { judgment: payload }
        // { judgment:
        //   { internalComment: this.vicePresidentAJudgment.internalComment,
        //     comment: this.vicePresidentAJudgment.comment,
        //     assignedTo: this.vicePresidentAJudgment.assignedTo ? this.vicePresidentAJudgment.assignedTo : {role: null, uid: null},
        //     boardUnanimous: this.vicePresidentAJudgment.boardUnanimous ? this.vicePresidentAJudgment.boardUnanimous : null
        //   }
        // }
      ).then((response) => {
        this.frontEndSuccessMsg('Τα δεδομένα αποθηκεύτηκαν με επιτυχία')
        this.$store.dispatch('LOAD_WORKING_APPLICATION', this.workingApplication.id)
      }).catch(err => {
        this.frontEndError('Σφάλμα κατά την προσωρινή αποθήκευση')
        this.catchError(err)
      })
    },
    modifyInternalComment (val) {
      this.modified = !(this.vicePresidentAJudgment.internalComment === this.internalComment)
    },
    modifyViceComment (val) {
      this.modified = !(this.vicePresidentAJudgment.comment === this.comment)
    },
    catchError (err) {
      this.backendError(err)
      throw err
    }
  },
  computed: {
    // showReappraisalBoardTool () {
    //   if (this.isReappraisal && this.fromBoard && this.vicePresidentAJudgment.boardUnanimous) {
    //     return true
    //   } else if (this.isReappraisal && this.fromBoard && !this.vicePresidentAJudgment.boardUnanimous && this.vicePresidentAJudgment.assignedTo.role === 'SpecialReappraisalBoardMember') {
    //     return true
    //   } else return false
    // },
    calcFileType () {
      if (this.fromReappraisalBoard) {
        return 26
      } else if (this.fromBoard) {
        return 24
      }
    },
    showReappraisalBoardTool: {
      get: function (val) {
        if (this.isReappraisal && this.fromBoard && this.vicePresidentAJudgment.boardUnanimous) {
          return true
        } else if (this.isReappraisal && this.fromBoard && !this.vicePresidentAJudgment.boardUnanimous && this.vicePresidentAJudgment.assignedTo.role === 'SpecialReappraisalBoardMember') {
          return true
        } else return false
      },
      set: function (value) {
        console.log('val', value)
        if (value) {
        } else {
          console.log('else set', this.vicePresidentAJudgment.assignedTo.role)
        }
      }
    },
    viceUploaded () {
      return this.viceAttachments.length > 0 && this.viceAttachments.slice(-1)[0].uid === this.currentUser.id
    },
    showDSDecisionText () {
      if (!this.isReappraisal || (this.isReappraisal && this.fromBoard && !this.vicePresidentAJudgment.boardUnanimous) || (this.isReappraisal && this.fromReappraisalBoard)) {
        return true
      } else return false
    },
    praktikoDSFound () {
      if (this.fromReappraisalBoard && this.workingApplication.attachedDocuments.slice().reverse().find(step => step.type === 26)) {
        return true
      } else if (this.fromBoard && this.workingApplication.attachedDocuments.slice().reverse().find(step => step.type === 24)) {
        return true
      } else return false
    },
    cannotSave () {
      if (!this.isReappraisal || (this.isReappraisal && !this.fromPrechecker && !this.vicePresidentAJudgment.boardUnanimous && !this.workingApplication.overdue)) {
        if ([undefined, null, ''].includes(this.vicePresidentAJudgment.comment) && !this.praktikoDSFound) {
          return true
        }
      } else if (this.vicePresidentAJudgment.assignedTo.role === 'SpecialReappraisalBoardMember' && (!this.reappraisalBoardExists || this.reappraisalBoard.members === [])) {
        return true
      } else return false
    },
    fromConsultant () {
      return this.workingApplication.applicationHistory.slice().reverse().find(item => item.applicationStatus === 'consultantW_Proponent') !== undefined
    },
    fromPresident () {
      return this.workingApplication.applicationHistory.slice(-1)[0].applicationStatus === 'viceW_President'
    },
    fromPrechecker () {
      return this.workingApplication.applicationHistory.slice(-2, -1)[0].applicationStatus === 'precheckerW_'
    },
    fromBoard () {
      return this.workingApplication.applicationHistory.slice(-1)[0].applicationStatus === 'viceW_Board'
    },
    fromReappraisalBoard () {
      return this.workingApplication.applicationHistory.slice(-1)[0].applicationStatus === 'viceW_ReappraisalBoard'
    },
    vicePresidentAJudgment () {
      return this.application.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'viceW_President' || step.applicationStatus === 'viceW_Prechecker' || step.applicationStatus === 'viceW_Board' || step.applicationStatus === 'viceW_ReappraisalBoard').judgment
    },
    reappraisalBoardJudgment () {
      return this.application.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'reappraisalBoardW_Vice').judgment
    },
    specialProponentProposal () {
      return this.application.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'proponentW_President').judgment.proposal
    },
    proponentInCharge () {
      return this.application.relevantAppl.specialProponent.surname + ' ' + this.application.relevantAppl.specialProponent.firstname
    },
    reviewProposalDate () {
      return this.application.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'proponentW_President').dateCompleted
    },
    presidentComment () {
      return this.application.applicationHistory.slice(0).reverse()
        .find(step => (step.applicationStatus === 'presidentW_Viewer' || step.applicationStatus === 'presidentW_ReappraisalBoard')).judgment.internalComment
    },
    boardJudgement () {
      return this.application.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'boardW_Consultant' || step.applicationStatus === 'boardW_Proponent' || step.applicationStatus === 'boardW_President' || step.applicationStatus === 'boardW_Vice')
    },
    users () {
      let lab
      return this.internalUsers.filter(user => (user.roles.filter(role => ['SpecialProponent', 'AcademicConsultant', 'ExecutiveBoardMember'].includes(role.name))).length > 0)
        .map(user => {
          user.roles.find(role => ['AcademicConsultant'].includes(role.name))
            ? lab = `${user.surname}, ${user.name.substring(0, 1)}., ${this.translate(user.roles.find(role => ['SpecialProponent', 'AcademicConsultant', 'ExecutiveBoardMember'].includes(role.name)).name)}, (${user.specialty.name})`
            : lab = `${user.surname}, ${user.name.substring(0, 1)}., ${this.translate(user.roles.find(role => ['SpecialProponent', 'AcademicConsultant', 'ExecutiveBoardMember'].includes(role.name)).name)}`
          return {
            key: user.id,
            label: lab
          }
        })
    },
    // users () {
    //   return this.eligibleUsers.map(user => {
    //     return {
    //       key: user.id,
    //       label: `${user.name}, ${user.surname}`
    //     }
    //   })
    // },
    ...mapGetters({ currentUser: 'currentUser', userScope: 'userScope', activeRole: 'activeRole', internalUsers: 'internalUsers', loadingInternalUsers: 'loadingInternalUsers' }),
    ...mapState([
      'assignedApplications',
      'viceAttachments',
      'workingApplication',
      'showWorkingApplication',
      'pendingNotifications',
      'loadingAssignedApplications',
      'loadingWorkingApplication',
      'BASE_URL',
      'activeLane'
    ])
  },
  watch: {
    cannotSave: (oldValue, newValue) => {
      this.cannotSave = newValue
    }
  }
}
</script>

<style lang="scss" scoped>
.commentText {
  width: 100%;
}
.el-checkbox__label {
  background-color: transparent;
}
.el-form-item {
  // color: rgb(30, 0, 128);
  // font-weight: bold;
  /* border-radius: 10px;
  border-style: solid;
  border-color: #7fa3bb green #86b8da yellow;
  border-width: 0px 0px 2px 0px; */
  padding-right: 5px;
}
hr {
  border-color: #7da0b8;
}
.el-alert {
  font-style: normal;
  text-align:left;
  display: inline;
}
.text-red {
  font-style:normal;
  color:crimson;
}
.agree-btn {
    background-color: #67c23a;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.disagree-btn {
    background-color: red;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.done-btn {
    background-color: #67c23a;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.pending-btn {
    background-color: orange;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.el-card {
  background-color: inherit;
  padding: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/VicePresidentAJudgment.vue